<script>
import ToolBar from '@/components/ToolBar.vue';
import { RouterView } from 'vue-router'

export default {
  components: { ToolBar, RouterView }
};
</script>

<template>
  <ToolBar></ToolBar>

  <RouterView />
</template>
